import { defineComponent as _defineComponent } from 'vue'
import { onMounted, PropType, toRefs, ref } from 'vue';
import { formatToDate, formatDatePickerDay } from '@/utils/datetime';
import { VForm } from 'vuetify/lib/components';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSection0',
  props: {
  publishedAt: {
    type: String as PropType<string | null>,
    default: null,
  },
  revisedAt: {
    type: String as PropType<string | null>,
    default: null,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:isValid", "update:publishedAt", "update:revisedAt"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:publishedAt', data: string | null): void;
  (e: 'update:revisedAt', data: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  creationDate: 'SDS作成日',
});

const isValid = ref<boolean>(false);
const form = ref<InstanceType<typeof VForm> | null>(null);
const modalPublishedAt = ref<boolean>(false);
const modalRevisedAt = ref<boolean>(false);

const closeDatePicker = (): void => {
  modalPublishedAt.value = false;
  modalRevisedAt.value = false;
};



const { publishedAt, revisedAt, isEditing } = toRefs(props);



const updateIsValid = (e: boolean) => {
  emits('update:isValid', e);
};

const updatePublishedAt = (e: string | null) => {
  emits('update:publishedAt', e);
};

const updateRevisedAt = (e: string | null) => {
  emits('update:revisedAt', e);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,$t, m, isValid, form, modalPublishedAt, modalRevisedAt, closeDatePicker, props, publishedAt, revisedAt, isEditing, emits, updateIsValid, updatePublishedAt, updateRevisedAt, formatToDate, formatDatePickerDay, VForm, sharedMessages }
}

})